import React, { memo, useCallback, } from 'react';
import Head from 'next/head';
import useFetch from '../src/hooks/useFetch';
import Avatar from '@material-ui/core/Avatar';
import Button from 'admin/src/components/Button';
import request from '../src/request/client';
import { useRouter, } from 'next/router';

export default memo(function Home() {
	const {
		data,
		isDataLoading,
	} = useFetch<any>({
		url: 'user',
		method: 'GET',
	});
	const router = useRouter();

	const {
		imageUrl,
		username,
		email,
	} = data;

	const onLogoutClick = useCallback(async () => {
		await request({
			url: 'user/logout',
		});
		router.push('redirect');
	}, [

	]);

	if (!data || isDataLoading) {
		return <div className={'flex w-full justify-center items-center'}>
			Logging you in...
		</div>;
	}

	return <>
		<Head>
			<title>
				Админ | OldMouse
			</title>

			<meta
				name="description"
				content="Админ | Old mouse"
			/>
		</Head>
		
		<div className={'flex flex-col justify-center items-center h-full'}>
			<div className={'flex flex-col justify-center items-center  p-5 rounded '}>
				<Avatar style={{
					width: '100px',
					height: '100px',
				}} alt={username} src={imageUrl} /> <b className={'text-lg'}>{username}</b>
				<b>{email}</b>
				<Button onClick={onLogoutClick}><div className={'bg-red-400 text-white px-5 rounded-md'}>Выход</div></Button>
			</div>
		</div>
	</>
});
